import { createSelector } from "@reduxjs/toolkit";

const selectPositionStatement = (state:any) => state.positionStatements;



export const selectClientPositionStatement = createSelector([selectPositionStatement], (data) => data?.clientList);
